var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHongkong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2387 9.07813C12.966 10.2125 12.4815 9.99613 12.2437 10.9854C10.8429 10.6486 9.98021 9.23999 10.317 7.83913C10.6537 6.43836 12.0624 5.57567 13.4632 5.91247C12.9876 7.89092 13.4827 8.06361 13.2387 9.07813Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60395 9.91871C10.5985 10.5286 10.243 10.9226 11.1103 11.4545C10.3571 12.6827 8.75092 13.0678 7.5227 12.3146C6.29453 11.5615 5.90936 9.95522 6.66255 8.72705C8.3972 9.79074 8.71431 9.37322 9.60395 9.91871Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28044 13.6355C10.1678 12.8781 10.4326 13.338 11.2065 12.6775C12.1419 13.7733 12.0117 15.4199 10.916 16.3553C9.82016 17.2907 8.17353 17.1604 7.23828 16.0647C8.78581 14.7436 8.4867 14.3129 9.28044 13.6355Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7145 15.092C12.2683 14.0141 12.7875 13.9042 12.3984 12.9642C13.7296 12.4133 15.2555 13.0458 15.8065 14.377C16.3574 15.7082 15.7248 17.234 14.3936 17.785C13.6156 15.9049 13.1136 16.0563 12.7145 15.092Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1618 12.2754C13.9987 12.3667 14.0545 11.8389 13.0403 11.9184C12.9277 10.4822 14.0009 9.22642 15.4372 9.11368C16.8734 9.00123 18.1292 10.0743 18.2418 11.5106C16.2132 11.6697 16.202 12.1939 15.1618 12.2754Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/e1dfee17.svg";
export { SvgHongkong as ReactComponent };